module.exports = __webpack_public_path__ + "static/media/YF56_3.82dd7434.jpg";